import { render, staticRenderFns } from "./Workdetail.vue?vue&type=template&id=5f11e9e2&scoped=true"
import script from "./Workdetail.vue?vue&type=script&lang=js"
export * from "./Workdetail.vue?vue&type=script&lang=js"
import style0 from "./Workdetail.vue?vue&type=style&index=0&id=5f11e9e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11e9e2",
  null
  
)

export default component.exports